
import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useSearchParams, useParams, useNavigate, useLocation } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import {
  Box, MenuItem, Typography, Container,
  Table,
  Card,
  TableCell,
  TableContainer,
  TableSortLabel,
  TableHead,
  TableRow,
  InputLabel,
  FormControl,
  Stack,
  Select,
  Divider,
  TextField,
  InputAdornment,
  Checkbox,
  TableBody,
  LinearProgress,
  Avatar,
  Badge,
  ToggleButtonGroup,
  ToggleButton,
  Paper
} from '@mui/material';


import { makeStyles } from '@mui/styles';
import debounce from 'lodash.debounce';


import "../css/GlobalStyles.css";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { DeviceOrderdButtons } from '../components/_dashboard/soundbox'
import { GetAllMerchants } from "../network/Merchants";


import { isoDateFormatInDmyhs, isoDateFToNow } from '../utils/formatTime';

// components
import Page from '../components/Page';

import { useAuth } from "../components/customContextProviders/AuthContext";
import MerchantListForSupport from './MechantListForSupport'

import { showFieldValueWithCheck, showLanguageLabelUsingCode, crossMarkString } from '../utils/Utilities'
import { APP_CONSTANTS } from '../URLConstants'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    // backgroundColor: '#44b700',
    // color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },




}));

const useStyles = makeStyles({

  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '75vh',
    maxHeight: '800px',
    marginRight: "3px",
    width: "100%",
    minWidth: "100%",

  },
  backGroundRed: {
    background: "rgba(195, 10, 10, .1)"
  },
  backGroundWhite: {
    background: 'white'
  }
});







let currentPage = 1
let isHasMerchantDataHasNextPage = true;


export default function MerchantListAudioCube() {


  const location = useLocation()
  const [devicesList, setDevicesList] = useState([]);
  const classes = useStyles();
  const [liveStatusVal, setLiveStatusVal] = useState("")


  const navigate = useNavigate();
  const { sessionUserData, organizationAudioCubeTerritories, audioCubeAppLevelSettings } = useAuth()


  const merchantsTableRef = useRef(null);

  const [organizationSelectedZone, setOrganizationSelectedZone] = useState("")
  const [isTestSoundBoxModalOpen, setIsTestSoundBoxModalOpen] = useState(false)
  const [isActivateDeviceModalOpen, setIsActivateDeviceModalOpen] = useState(false)
  const [locationFilterVal, setLocationFilterVal] = useState('ALL');
  const [languageFilterVal, setLanguageFilterVal] = useState("")
  const [selectedDeviceIdForTestPaymnt, setSelectedDeviceIdForTestPaymnt] = useState("")
  const [audioCubeMerchantListData, setAudioCubeMerchantListData] = useState([])
  const [selectedDevicesList, setSelectedDevicesList] = useState([]);
  const [audioCubeMerchantListDataLoading, setAudioCubeMerchantListDataLoading] = useState(false)
  const [merchantSearchByFilterVal, setMerchantSearchByFilterVal] = useState("")
  const [searchTimer, setSearchTimer] = useState(null)

  const [filterMetas, setFilterMetas] = useState({ orderByFiled: "", orderBy: "DESC" });



  useEffect(() => {
    fetchMerchants(location?.state?.organizationData?.id === undefined || location?.state?.organizationData?.id === null ?
      sessionUserData?.user?.organization?.id : location?.state?.organizationData?.id
      , currentPage, 10, "", "", merchantSearchByFilterVal, organizationSelectedZone, languageFilterVal, liveStatusVal, "LOAD",)
    return () => {
      currentPage = 1;
      isHasMerchantDataHasNextPage = true
      setAudioCubeMerchantListData([])
    }
  }, []);





  const handleScroll = () => {
    const card = merchantsTableRef.current;

    if (card) {
      const scrollPercentage = (card.scrollTop / (card.scrollHeight - card.clientHeight)) * 100;


      if (scrollPercentage > 90 && isHasMerchantDataHasNextPage) {
        if (!audioCubeMerchantListDataLoading) {
          currentPage += 1
          fetchMerchants(location?.state?.organizationData?.id === undefined || location?.state?.organizationData?.id === null ?
            sessionUserData?.user?.organization?.id : location?.state?.organizationData?.id, currentPage, 10, "", "",
            merchantSearchByFilterVal, organizationSelectedZone,
            languageFilterVal, liveStatusVal, "LOAD", filterMetas?.orderBy, filterMetas?.orderByFiled)
        }
      }
    }



  };



  function fetchMerchants(organizationId, currentPage, limit, _date, _merchantId, searchBy, zoneName, language, liveStatus, type, sortBy, sortByField) {
    setAudioCubeMerchantListDataLoading(true)

   

    const where = {
      ...(organizationId && { organizationId }),
      ...(liveStatus && { device_live_status: liveStatus }),
      ...(language && { language }),
      ...(zoneName && { merchantbranch: { zone: zoneName } }),
      ...(searchBy && { search:searchBy})
  };

    GetAllMerchants(currentPage, limit,where,sortBy, sortByField).then((res) => {
      setAudioCubeMerchantListDataLoading(false)
      isHasMerchantDataHasNextPage = res?.data?.hasNextPage;

      if (type === 'LOAD')
      setAudioCubeMerchantListData(prevList => [...prevList, ...(res?.data?.data ?? [])]);


      else if (type === 'SEARCH') {
        setAudioCubeMerchantListData([]);
        setAudioCubeMerchantListData(res?.data?.data);
      }


    }).catch((_error) => {
      setAudioCubeMerchantListDataLoading(false)

    })


  }


  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = audioCubeMerchantListData?.map((row) => row?.key);
      setSelectedDevicesList(newSelected);
    } else {
      setSelectedDevicesList([]);
    }
  };

  const handleRowSelectClick = (_event, id) => {
    const selectedIndex = selectedDevicesList.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedDevicesList, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedDevicesList.slice(1));
    } else if (selectedIndex === selectedDevicesList.length - 1) {
      newSelected = newSelected.concat(selectedDevicesList.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedDevicesList.slice(0, selectedIndex),
        selectedDevicesList.slice(selectedIndex + 1)
      );
    }
    setSelectedDevicesList(newSelected);
  };
  const isSelected = (id) => selectedDevicesList.indexOf(id) !== -1;


  const handleOrganizatioZoneValChange = (event) => {
    setOrganizationSelectedZone(event.target.value)
    currentPage = 1;
    fetchMerchants(location?.state?.organizationData?.id === undefined || location?.state?.organizationData?.id === null ?
      sessionUserData?.user?.organization?.id : location?.state?.organizationData?.id, currentPage, 10, "", "", merchantSearchByFilterVal, event.target.value, languageFilterVal, liveStatusVal, "SEARCH")

  }


  const handleLanguagueFilterValChnage = (event) => {
    setLanguageFilterVal(event.target.value)
    currentPage = 1;
    fetchMerchants(location?.state?.organizationData?.id === undefined || location?.state?.organizationData?.id === null ?
      sessionUserData?.user?.organization?.id : location?.state?.organizationData?.id, currentPage, 10, "", "", merchantSearchByFilterVal, organizationSelectedZone, event.target.value, liveStatusVal, "SEARCH")

  }




  const handleMerchantSearchByFilterVal = (event) => {
    setMerchantSearchByFilterVal(event?.target?.value)
    currentPage = 1;

    clearTimeout(searchTimer)
    const newTimer = setTimeout(() => {
      fetchMerchants(location?.state?.organizationData?.id === undefined || location?.state?.organizationData?.id === null ?
        sessionUserData?.user?.organization?.id : location?.state?.organizationData?.id, currentPage, 10, "", "", event?.target.value, organizationSelectedZone, languageFilterVal, liveStatusVal, "SEARCH")
    }, 1000)
    setSearchTimer(newTimer)
  }


  const handleLiveStatusChange = (e) => {
    setLiveStatusVal(e?.target?.value)
    currentPage = 1;
    fetchMerchants(location?.state?.organizationData?.id === undefined || location?.state?.organizationData?.id === null ?
      sessionUserData?.user?.organization?.id : location?.state?.organizationData?.id, currentPage, 10, "", "", merchantSearchByFilterVal, organizationSelectedZone, languageFilterVal, e?.target?.value, "SEARCH")

  }


  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };


  const onRequestSort = (_event, property) => {
    const isAscending = filterMetas?.orderByFiled === property && filterMetas?.orderBy === 'ASC';
    setFilterMetas({ ...filterMetas, orderByFiled: property, orderBy: isAscending ? 'DESC' : 'ASC' });

    currentPage = 1;
    fetchMerchants(location?.state?.organizationData?.id === undefined || location?.state?.organizationData?.id === null ?
      sessionUserData?.user?.organization?.id : location?.state?.organizationData?.id, currentPage, 10, "", "",
      merchantSearchByFilterVal,
      organizationSelectedZone, languageFilterVal, liveStatusVal, "SEARCH",
      isAscending ? 'DESC' : 'ASC', property
    )
  };




  return (
    <Page title="Merchants" data-testid='merchants-list'>
      <Box sx={{ pl: 3 }}>     
        <DeviceOrderdButtons />

        </Box> 
      <Container maxWidth='false'>
              <Card sx={{ height: '79vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {audioCubeMerchantListDataLoading ? <LinearProgress color="success" /> : null}

          <Stack direction={{xs:"column", md:"row"}} alignItems="center" justifyContent="space-between" sx={{ pl: 3, pr: 3, pt: 2, pb: {xs:1, md:2} }} mt={1} mb={1} spacing={{xs:1, md:'auto'}}>
            <Stack direction="row" spacing={{xs:1, md:2}} alignItems="center" justifyContent="flex-start" >
              <Typography sx={{ fontSize: 16, fontWeight: 'bold', display: {xs: 'none', md:"block"} }}>
                Filter By
              </Typography>


              <FormControl size="small" data-testid='zone-dropDown' sx={{ minWidth: {xs: 80, md:150} }}>
                <InputLabel id="device-select-label">Zone </InputLabel>
                <Select
                  labelId="device-select-label"
                  id="device-select"
                  value={organizationSelectedZone}
                  onChange={handleOrganizatioZoneValChange}
                  label="Zone">
                  <MenuItem value="">ALL</MenuItem>
                  {
                    organizationAudioCubeTerritories?.filter(obj => obj?.parent_id === "0")?.map((row) => (
                      <MenuItem key={row?.name} value={row?.name} sx={{ p: 1.5 }}>{row?.name}</MenuItem>
                    ))
                  }

                </Select>
              </FormControl>

              {
                (audioCubeAppLevelSettings?.language !== null && audioCubeAppLevelSettings?.language !== undefined &&
                  Object.keys(audioCubeAppLevelSettings?.language).length !== 0) &&
                  <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="language-filter-select-label">Language </InputLabel>
                    <Select
                      labelId="language-filter-select-label"
                      id="language-filter-select"
                      value={languageFilterVal}
                      label="Language "
                      onChange={handleLanguagueFilterValChnage}
                    >
                      <MenuItem value="" sx={{ p: 1.5 }}>  ALL</MenuItem>
                      {
                        Object.entries(audioCubeAppLevelSettings?.language)?.map(([key, value]) => (
                          <MenuItem key={value} value={key} sx={{ p: 1.5 }}>{value}</MenuItem>
                        ))
                      }

                    </Select>
                  </FormControl>
                 
              }

              <FormControl size="small" sx={{ minWidth: 120 }}>
                <TextField
                  size="small"
                  label="Search"
                  placeholder="Search"
                  value={merchantSearchByFilterVal}
                  onChange={handleMerchantSearchByFilterVal}
                  data-testid='search-filter'
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}

                />
              </FormControl>


            </Stack>

            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end" >


              <ToggleButtonGroup
                sx={{

                  '& .Mui-selected': {
                    color: "#171D40 !important",
                    fontWeight: '700 !important',
                    backgroundColor: '#FFF !important'

                  },
                  '& .MuiToggleButton-root:hover': {
                    color: "#171D40 !important"
                  },
                  '& .MuiToggleButton-root': {
                    backgroundColor: '#FFF',

                    textAlign: 'center',
                    fontFamily: "Mulish",
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal',
                    color: '#B0B9C7',
                    padding: '8px'

                  }

                }}
                color="primary"
                value={liveStatusVal}
                size="small"
                exclusive
                onChange={handleLiveStatusChange}
                aria-label="Device Live Status"
              >
                <ToggleButton value="">All</ToggleButton>
                <ToggleButton value="Online">Online</ToggleButton>
                <ToggleButton value="Offline">Offline</ToggleButton>
              </ToggleButtonGroup>


              {/* <Button variant="contained" className="secondayDashboardButton" size="small" sx={{ mr: 1, minHeight: '5vh', minWidth: 110 }}  >SMS</Button> */}
            </Stack>
          </Stack>
          <Divider sx={{ m: 1 }} />


          {/* <div style={{  width: '100%' }}>
              <DataGrid
                rows={smartLockDeviceListData}
                columns={columns}
                disableColumnFilter={true}
                disableColumnSort={true}
                pagination={false} 
                pageSize={smartLockDeviceListData.length}
                checkboxSelection
              />
        </div> */}

          {
            sessionUserData?.user?.role === APP_CONSTANTS.L1_SUPPORT_USER_ROLE || sessionUserData?.user?.role === APP_CONSTANTS.L2_SUPPORT_USER_ROLE ?
              <MerchantListForSupport audioCubeMerchantListData={audioCubeMerchantListData}
                handleScroll={handleScroll}
                mref={merchantsTableRef}
                filterMetas={filterMetas}
                createSortHandler={createSortHandler}
              />
              :

              <>
                {
                 ( audioCubeMerchantListData !== null && audioCubeMerchantListData !== undefined) &&
                    <TableContainer data-testid='merchant-table-container' component={Paper} sx={{ maxHeight: 600, overflowY: 'scroll' }} ref={merchantsTableRef} onScroll={handleScroll}>
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox"  sticky="left">
                              <Checkbox
                                checked={selectedDevicesList.length === audioCubeMerchantListData?.length}
                                onChange={handleSelectAllClick}
                              />
                            </TableCell>
                            { /* eslint-disable */
                              <TableCell align="center"></TableCell>
                              /* eslint-enable */
                            }

                            <TableCell align="center" 
                             sx={{
                              minWidth: '10vw',
                              fontWeight: 700,                          
                              position: 'sticky',
                              left: 0 ,
                              zIndex:  15 ,
                              
                            }}
                            
                           >
                              Merchant Id
                            </TableCell>
                            <TableCell align="center" sx={{ minWidth: '15vw', fontWeight: 700, position: 'sticky', left: '8vw', zIndex: 1 }}>
                              <TableSortLabel
                                active={filterMetas?.orderByFiled === 'name'}
                                direction={filterMetas?.orderByFiled === 'name' ? filterMetas?.orderBy : 'ASC'}
                                onClick={createSortHandler('name')}
                                IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                                Merchant Name
                              </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" sx={{ minWidth: '12vw', fontWeight: 700 }}>
                            <TableSortLabel
                                active={filterMetas?.orderByFiled === 'activated'}
                                direction={filterMetas?.orderByFiled === 'activated' ? filterMetas?.orderBy : 'ASC'}
                                onClick={createSortHandler('activated')}
                                IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                                Status
                              </TableSortLabel>
                               
                               
                               </TableCell>
                            <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 700 }}>Last Trans</TableCell>
                            <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 700 }}>
                                Rent Status
                            </TableCell>
                            <TableCell align="center" sx={{ minWidth: '15vw', fontWeight: 700 }}>
                              <TableSortLabel
                                active={filterMetas?.orderByFiled === 'requested_date'}
                                direction={filterMetas?.orderByFiled === 'requested_date' ? filterMetas?.orderBy : 'ASC'}
                                onClick={createSortHandler('requested_date')}
                                IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                                Onboarded
                              </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" sx={{ minWidth: '13vw', fontWeight: 700 }}>
                              <TableSortLabel
                                active={filterMetas?.orderByFiled === 'active_date'}
                                direction={filterMetas?.orderByFiled === 'active_date' ? filterMetas?.orderBy : 'ASC'}
                                onClick={createSortHandler('active_date')}
                                IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                                Installation Date
                              </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" sx={{ minWidth: '11vw', fontWeight: 700 }}>
                              Zone
                            </TableCell>

                            <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 700 }}>Language</TableCell>

                            <TableCell align="center" sx={{ minWidth: '15vw', fontWeight: 700 }}>
                              <TableSortLabel
                                active={filterMetas?.orderByFiled === 'last_activity_date'}
                                direction={filterMetas?.orderByFiled === 'last_activity_date' ? filterMetas?.orderBy : 'ASC'}
                                onClick={createSortHandler('last_activity_date')}
                                IconComponent={filterMetas?.orderBy === 'ASC' ? ArrowUpwardIcon : ArrowDownwardIcon}>
                                Last Updated
                              </TableSortLabel>

                            </TableCell>

                            {/* <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 700 }}>Sim Number</TableCell>
                            <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 700 }}>Campaign</TableCell>
                            <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 700 }}>Battery</TableCell> */}
                            <TableCell align="center" sx={{ minWidth: '12vw', fontWeight: 700 }}>Messages Sent/Received</TableCell>
                            <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 700 }}>Notification Missed</TableCell>
                            {/* <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 700 }}>Reboot Count</TableCell>
                            <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 700 }}>FW Version</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {
                            // (rowsPerPage > 0
                            //   ? soundboxDeviceListData?.lists?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            //   : soundboxDeviceListData?.lists
                            // )

                            audioCubeMerchantListData?.map((row) => {
                              const isItemSelected = isSelected(row?.key);
                              return (
                                <TableRow
                                  key={row?.key}
                                  hover
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                  onClick={(event) => handleRowSelectClick(event, row?.key)}
                                  input type="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  selected={isItemSelected}
                                >
                                  <TableCell padding="checkbox" sticky="left"  >
                                    <Checkbox checked={isItemSelected} />
                                  </TableCell>
                                  <TableCell sticky="left">
                                    <StyledBadge
                                      overlap="circular"
                                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                      variant="dot"
                                      sx={{
                                        '& .MuiBadge-badge': {
                                          backgroundColor: row?.device_live_status?.toUpperCase() === 'ONLINE' ? 'green' : 'red',
                                          color: row?.device_live_status?.toUpperCase() === 'ONLINE' ? 'green' : 'red'
                                        },
                                        '.MuiBadge-badge::after': {
                                          animation: row?.device_live_status?.toUpperCase() === 'ONLINE' ? 'ripple 1.2s infinite ease-in-out' : 'none',
                                        }
                                      }}>
                                      <Avatar alt={row?.name} />
                                    </StyledBadge>
                                  </TableCell>

                                  <TableCell className="merchantTableListLabel" component="th" scope="row"  sx={{
                                    position: 'sticky',
                                    left: 0,
                                    zIndex: 10,
                                    background: '#fff',
                                    boxShadow: '2px 0 5px -5px rgba(0,0,0,0.8)',
                                    borderRight: '3px solid rgba(0,0,0,0.1)', // Add a subtle right border
                                  }}>
                                    <RouterLink
                                      to="/dashboard/soundboxdevicedetails"
                                      state={{ merchantId: row?.key, organizationId: row?.organizationId }} >
                                      {crossMarkString(row?.key)}
                                    </RouterLink>
                                  </TableCell>
                                  <TableCell className="merchantTableListLabel"  >{row?.name}</TableCell>
                                  <TableCell className="merchantTableListLabel" >{showFieldValueWithCheck(row?.activated ? "Assigned":"Not Assigned")}</TableCell>
                                  <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.last_transaction_amt)} </TableCell>
                                  <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.rent_to_be_collected)} </TableCell>
                                  <TableCell className="merchantTableListLabel" >
                                    <Typography className="merchantTableListLabel"> On {isoDateFormatInDmyhs(row?.requested_date)}</Typography>
                                    <Typography className="merchantTableListLabel"> By {showFieldValueWithCheck(row?.onboarding_channel)} </Typography>
                                  </TableCell>
                                  <TableCell className="merchantTableListLabel" >{showFieldValueWithCheck(isoDateFormatInDmyhs(row?.active_date))} </TableCell>

                                  <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.merchantbranch?.zone)} </TableCell>
                                  <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(showLanguageLabelUsingCode(row?.language))} </TableCell>
                                  <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(isoDateFToNow(row?.last_activity_date))}  </TableCell>
                                  {/* <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(crossMarkString(row?.sim))} </TableCell>
                                  <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(showLanguageLabelUsingCode(row?.language))} </TableCell>
                                  <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.campaign)} </TableCell> */}
                                  {/* <TableCell className="merchantTableListLabel"  >
                                    {
                                      row?.battery !== null && row?.battery !== undefined ?
                                        <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                                          <Card sx={{ width: "10px", height: "10px", backgroundColor: getColorAccordingSevertity(row.battery) }} />
                                          <Typography > {row?.battery} %</Typography>
                                        </Stack>
                                        :
                                        <Typography >-----</Typography>

                                    }
                                  </TableCell> */}
                                  <TableCell className="merchantTableListLabel" > {showFieldValueWithCheck(row?.total_message)}/{showFieldValueWithCheck(row?.delivered)}</TableCell>
                                  <TableCell className="merchantTableListLabel" >{showFieldValueWithCheck(row?.missed)}</TableCell>
                                  {/* <TableCell className="merchantTableListLabel" >{showFieldValueWithCheck(row?.reboot_count)}</TableCell>
                                  <TableCell className="merchantTableListLabel" >{showFieldValueWithCheck(crossMarkString(row?.fw_version))} </TableCell> */}

                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>

                }

              </>

          }

          {audioCubeMerchantListDataLoading && <LinearProgress color="success" />}
        </Card>
      </Container>

    

    </Page>
  );
}

